import ConceptToggle from '@/returns/components/ConceptToggle/ConceptToggle'
import { getConceptAmountError, hasConceptError, isExpandableConcept, isFeeConcept } from '@/returns/helpers/helpers'

import { getLineItemsToShowByConcept } from '../helpers'

const RefundConceptToggle = ({
  concept,
  currency,
  editable,
  lineItems,
  newItems,
  onClickInConcept,
  onChangeConceptAmount,
  onChangeItemAmount,
}) => {
  const handleToggle = () => {
    onClickInConcept(concept.id)
  }

  const handleChangeAmount = amount => {
    onChangeConceptAmount(concept.id, amount)
  }

  const handleChangeItemAmount = (itemId, amount) => {
    onChangeItemAmount(concept.id, itemId, amount)
  }

  return (
    <ConceptToggle
      label={concept.label}
      selected={concept.selected}
      amount={concept.amount}
      maxAmount={concept.max_amount}
      currency={currency}
      isNegative={isFeeConcept(concept)}
      editable={editable}
      expandable={isExpandableConcept(concept)}
      items={concept.items}
      lineItems={getLineItemsToShowByConcept({ conceptKey: concept.concept, lineItems, newItems })}
      error={getConceptAmountError(concept)}
      hasError={hasConceptError(concept)}
      onToggle={handleToggle}
      onChangeAmount={handleChangeAmount}
      onChangeItemAmount={handleChangeItemAmount}
    />
  )
}

export default RefundConceptToggle
